import React from 'react';
import Icon from 'components/AppIcon';

const tips = [
  {
    icon: 'RefreshCw',
    title: 'Update Saved Passwords',
    description: 'Update your password in your browser and any password managers you use.'
  },
  {
    icon: 'Shield',
    title: 'Use a Unique Password',
    description: 'Avoid reusing this password on other websites or services.'
  },
  {
    icon: 'Bell',
    title: 'Watch for Suspicious Activity',
    description: 'If you did not request this reset, contact support immediately.'
  }
];

const SecurityTips = () => {
  return (
    <>
      <div className="flex items-center gap-2 mb-4">
        <Icon name="ShieldAlert" size={18} className="text-primary" />
        <h3 className="text-sm font-semibold text-text-primary">Security Recommendations</h3>
      </div>

      <div className="space-y-3">
        {tips?.map((tip, idx) => (
          <div key={idx} className="flex items-start gap-3">
            <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={tip?.icon} size={16} className="text-primary" />
            </div>
            <div>
              <p className="text-sm font-medium text-text-primary">{tip?.title}</p>
              <p className="text-xs text-text-secondary mt-0.5 leading-relaxed">{tip?.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 pt-4 border-t border-border">
        <p className="text-xs text-text-secondary text-center">
          Need help? Contact{' '}
          <a href="mailto:support@lawdesk.co.ke" className="text-primary hover:underline font-medium">
            support@lawdesk.co.ke
          </a>
        </p>
      </div>
    </>
  );
};

export default SecurityTips;
